import * as React from 'react';
import * as S from './styles';
import { IProps } from './types';
import WidgetCall from '../WidgetCall';

const MovilPreview: React.FC<IProps> = (props) => {

    const renderWidgetCall = (widgetCall: string|undefined, index: number) => {
        return (
            <>
                <S.WidgetContainer bgColor={(props.backgroundColors.length > index) ? props.backgroundColors[index] : "#fff"} firstWidget={index === 0} lastWidget={index === props.widgetCalls.length-1}>
                    <WidgetCall widgetCall={widgetCall} widgetIndex={index} />
                </S.WidgetContainer>
                {
                    index !== (props.widgetCalls.length - 1) && 
                    <S.SeparatorContainer selectedTab={props.selectedTab}>
                        <S.Separator />
                    </S.SeparatorContainer>
                }
            </>
        );
    }

    return (
        <S.MainContainer>
            <S.MovilContainer>
            {
                props.widgetCalls.map((widgetCall: string|undefined, index: number) => {
                    if (widgetCall!=undefined)
                        return renderWidgetCall(widgetCall, index);
                })
            }
            </S.MovilContainer>
        </S.MainContainer>
    )
}

export default MovilPreview;
